export interface ICPFValidator {
  format: (input: string) => string
  parse: (input: string) => string
  isValid: (input: string) => boolean
}
class CPFValidator implements ICPFValidator {
  constructor(private readonly cpf: ICPFValidator) {}

  format = (input: string) => {
    return this.cpf.format(input)
  }

  parse = (input: string) => {
    return this.cpf.parse(input)
  }

  isValid = (input: string) => {
    return this.cpf.isValid(input)
  }
}

export { CPFValidator }
